module.exports = __webpack_public_path__ + "media/components/country-flag/static/ag-09ff053b286c26e55e4b2b3b662f1412.svg";